module.exports = __webpack_public_path__ + "static/media/FlyBirdsBox_RoseGold_Icons-mail.81ec477a.png";